import Papa from 'papaparse';

/** Max data rows (excluding the single header row) allowed for a trial catalog upload. */
export const TRIAL_MAX_DATA_ROWS = 20;

/** Rows papaparse parses before stopping — header + max data + 1 to detect overflow. */
const PREVIEW_ROW_LIMIT = TRIAL_MAX_DATA_ROWS + 2;

/**
 * A NUL char as the quote character effectively disables quote grouping — it
 * cannot appear in a text feed. We only want to COUNT rows, so newlines must
 * always break rows. With papaparse's default `"` quote, a real TSV/CSV field
 * that starts with an unbalanced `"` (e.g. a title like `"Premium TV`) makes the
 * parser swallow every following line until the next `"`, collapsing a 100-row
 * file to a couple of records and silently bypassing the limit.
 */
const NO_QUOTE_CHAR = String.fromCharCode(0);

/**
 * Resolves true when a CSV/TSV catalog file has more than `TRIAL_MAX_DATA_ROWS`
 * data rows (i.e. more than header + 20 rows). Uses papaparse's `preview` so
 * only the first ~22 rows are parsed — the 25 MB file is never read in full.
 * Quote grouping is disabled (see `NO_QUOTE_CHAR`) so every newline counts as a
 * row. Parse errors resolve false so the real upload/backend path can surface them.
 */
export function hasTooManyDataRows(file: File): Promise<boolean> {
  return new Promise((resolve) => {
    Papa.parse(file, {
      preview: PREVIEW_ROW_LIMIT,
      skipEmptyLines: 'greedy',
      quoteChar: NO_QUOTE_CHAR,
      complete: (results) => {
        // data.length counts the header too, so the limit is max data rows + 1.
        resolve(results.data.length > TRIAL_MAX_DATA_ROWS + 1);
      },
      error: () => {
        resolve(false);
      },
    });
  });
}
